const KEY = "token"

export function createTokenStore({ secure, legacy }) {
  let current = null

  async function migrate() {
    const legacyToken = await legacy.get(KEY)
    if (!legacyToken) return secure.getItem(KEY)

    const moved = await secure
      .setItem(KEY, legacyToken)
      .then(() => secure.getItem(KEY))
      .catch(() => null)
    if (moved === legacyToken) await legacy.remove(KEY)
    return legacyToken
  }

  async function load() {
    try {
      return await (secure ? migrate() : legacy.get(KEY))
    } catch {
      return null
    }
  }

  return {
    get() {
      if (!current) current = load()
      return current
    },
    async set(token) {
      current = Promise.resolve(token)
      await (secure ? secure.setItem(KEY, token) : legacy.set(KEY, token))
    },
    async clear() {
      current = Promise.resolve(null)
      await Promise.all([legacy.remove(KEY), secure && secure.removeItem(KEY)])
    },
  }
}
